export default __webpack_public_path__ + "static/media/bookmark-plus.977d621d.svg";